import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ParamterType } from '@sdbn/appclient';
import { OuthandedSupplementaryEquipment } from '../../register-entrance-leave.model';

@Component({
  selector: 'app-outhanded-supplementary-equipment-item',
  templateUrl: './outhanded-supplementary-equipment-item.component.html',
  styleUrls: ['./outhanded-supplementary-equipment-item.component.scss']
})
export class OuthandedSupplementaryEquipmentItemComponent implements OnInit {

  ParamterType = ParamterType;

  @Input() supplementaryEquipment: OuthandedSupplementaryEquipment;

  @Output() changed = new EventEmitter<null>();

  formGroup = new FormGroup({
    checked: new FormControl(false, [])
  });

  constructor() { }

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(value => {
      this.supplementaryEquipment.selected = value.checked;
      this.changed.next();
    });

  }

}
